import * as Displays from 'support/displays'
import React from 'react'
import { WhenModelValue } from '@morningtrain/react-resources'
import { GoodSmiley } from 'ui/icons/smileys'

export default function CleaningDepartment () {
  return (
    <div className='flex items-center'>
      <WhenModelValue name='has_elite_badge' condition={true}>
        <GoodSmiley fill='white' className={'inline w-8 h-8 rounded-full bg-green-400 p-1 mr-2'}/>
      </WhenModelValue>
      <Displays.Text name={'name'}/>
    </div>
  )
}
